async function dispatchAction(store: any, action: string, payload: any = {}) {
    return await store.dispatch(`transaction/${action}`, payload);
}

export const getTransactionSummary = (store: any, payload: any) => dispatchAction(store, 'getTransactionSummary', payload);

export const getObjectivesSummary = (store: any, payload: any) => dispatchAction(store, 'getObjectivesSummary', payload);

export const storeObjectives = (store: any, objectives: any) => dispatchAction(store, 'storeObjectives', { objectives });

export const storeOffices = (store: any) => dispatchAction(store, 'storeOffices');
